import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";
import RatingBadge from "@/components/base/RatingBadge";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}影视海报`}
          title={`${movie.title} - 激情视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-80" />
        {rank && (
          <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 font-display text-sm font-semibold text-background-50">
            {rank}
          </span>
        )}
        <div className="absolute right-2 top-2">
          <RatingBadge value={movie.rating} size="sm" />
        </div>
        <div className="absolute inset-x-0 bottom-0 p-3">
          <div className="mb-1.5 flex flex-wrap gap-1">
            <span className="rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
              {movie.type}
            </span>
            <span className="rounded-md bg-background-50/90 px-2 py-0.5 text-xs font-medium text-foreground-800">
              {movie.region}
            </span>
          </div>
          <h3 className="truncate text-base font-semibold text-background-50">{movie.title}</h3>
        </div>
      </div>
      <div className="p-3">
        <p className="truncate text-sm text-foreground-700">
          {movie.cast.slice(0, 3).join(" / ")}
        </p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{movie.year} 年</span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line" />
            {movie.popularity > 9000 ? "超热" : movie.popularity > 7000 ? "热门" : "推荐"}
          </span>
        </div>
      </div>
    </Link>
  );
}